import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { useSite } from "../../lib/site-context";

const WhatsAppIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.82 9.82 0 0 0 1.523 5.26l-.999 3.648 3.965-1.607zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
  </svg>
);

// Fixed bottom action bar for mobile / tablet only (< lg).
// Keeps the top header calm and surfaces the key conversion actions.
export default function MobileActionBar() {
  const { settings, t } = useSite();
  const c = settings?.contact || {};
  const phone = c.phone || c.mobile || "";
  const wa = c.whatsapp || c.mobile || c.phone || "";
  const telHref = `tel:${phone.replace(/[^+\d]/g, "")}`;
  const waMsg = t(
    "Hallo Dr. B.-Digitec, ich interessiere mich für die digitale Zusammenarbeit mit Ihrem Labor.",
    "Hello Dr. B.-Digitec, I'm interested in working digitally with your lab."
  );
  const waHref = `https://wa.me/${wa.replace(/[^\d]/g, "")}?text=${encodeURIComponent(waMsg)}`;

  return (
    <div
      data-testid="mobile-action-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 px-3 pt-1"
      style={{
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 0.25rem)",
        background: "rgba(236,235,229,0.88)",
        WebkitBackdropFilter: "blur(18px) saturate(160%)",
        backdropFilter: "blur(18px) saturate(160%)",
        borderTop: "1px solid var(--line-soft)",
      }}
    >
      <div className="flex items-center gap-2.5 max-w-md mx-auto">
        <Link
          to="/praxis-check"
          data-testid="mobilebar-praxis-check"
          className="brut-btn flex-1 justify-center !py-0 h-12 text-[14px]"
        >
          {t("Praxis-Check", "Practice-Check")} <ArrowUpRight size={16} />
        </Link>
        {wa && (
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            data-testid="mobilebar-whatsapp"
            className="shrink-0 w-12 h-12 rounded-2xl flex items-center justify-center bg-[var(--ink)] text-[var(--bg)] active:scale-95 transition-transform"
            style={{ boxShadow: "var(--neu-raised-sm)" }}
          >
            <WhatsAppIcon size={22} />
          </a>
        )}
        {phone && (
          <a
            href={telHref}
            aria-label={t("Anrufen", "Call")}
            data-testid="mobilebar-phone"
            className="shrink-0 w-12 h-12 rounded-2xl flex items-center justify-center bg-[var(--ink)] text-[var(--bg)] active:scale-95 transition-transform"
            style={{ boxShadow: "var(--neu-raised-sm)" }}
          >
            <Phone size={20} />
          </a>
        )}
      </div>
    </div>
  );
}
